<template>
<div :class="`card ${isDebug ? 'add-border':''}`" data-tipo-componente="componente-tipo-resposta-texto">
    <!-- Card image -->

    <!-- Card content -->
    <div class="card-body">
      <!-- Title -->
      <div class="row">
        <div class="col-12">
          <h6 class="card-title">
            <a>{{ pergunta.ordemExibicao }} ) {{ pergunta.titulo }}</a>
            <span
              v-if="pergunta.obrigatoria"
              style="color: red; font-weight: bold"
              >*</span
            >
          </h6>
          <h6>
            <small v-if="pergunta.subTitulo" class="text-muted">
              {{ pergunta.subTitulo }}
            </small>
          </h6>
        </div>    
      </div>
      <!-- Text -->
      <div
        class="container-fluid"
        v-if="pergunta.descricao"
        v-html="pergunta.descricao"></div>
     
        <!--opcoes de resposta -->
          <div class="row">
            <div
              class="opcoes-resposta col-lg-6 col-md-6 col-xs-10 col-sm-10 no-gutters"
              :key="opcaoResposta.opcaoRespostaId"
              v-for="(opcaoResposta, index) in pergunta.opcoesResposta">
               
            
              <div class="form-check">
               
                <input
                  :tabindex="opcaoResposta.ordemExibicao + index"
                  class="form-check-input"
                  ref="checkbox"
                  @click="responderPergunta(pergunta, opcaoResposta, $event)"
                  v-model="respostasSelecionadas"
                  type="checkbox"
                  :value="opcaoResposta"
                  :id="`checkbox_${pergunta.perguntaId}_${opcaoResposta.opcaoRespostaPerguntaId}`"
                  :name="`checkbox_${pergunta.perguntaId}_${opcaoResposta.opcaoRespostaPerguntaId}`"
                />
                
                <label
                  class="form-check-label"
                  :for="`checkbox_${pergunta.perguntaId}_${opcaoResposta.opcaoRespostaPerguntaId}`"
                  >{{ opcaoResposta.valor }}
                </label>
              </div>
            </div>
          </div>
 
    
      <!-- <p>Respstas: {{ respostasSelecionadas }}</p> -->
    </div>
  </div>
</template>

<script>
import repostaPerguntaMethodsMixin from "./ResponderPerguntaMixin";
export default {
  mixins: [repostaPerguntaMethodsMixin],
  name: "comp-pergunta-checkbox-vertical",
  props: ["pergunta", "permitirResponder"],
  data() {
    return {
      resposta: "",
      respostasSelecionadas: [],
    };
  },
  computed: {
    botaoDesabilitado() {
      return this.resposta === "" || !this.permitirResponder;
    },
    formulario() {
      return this.$store.state.formulario;
    },
  },
  methods: {
    responderPergunta(pergunta, opcaoResposta, event) {
      const elementRefId = `checkbox_${pergunta.perguntaId}_${opcaoResposta.opcaoRespostaPerguntaId}`;
      const checked = event.target.checked;

      const {
        opcaoRespostaId,
        perguntaId,
        perguntasEncadeadasIds,
        tipoEncadeamentoPergunta,
        encadeamentosPerguntasIds,
        sessaoFormularioPerguntaId,
        sessaoFormularioId,
        valor,
      } = opcaoResposta;


      //verificar se existe pergunta encadeada a resposta
      const configPerguntaEncadeada = {
        ...pergunta,
        perguntaId,
        opcaoRespostaId,
        perguntasEncadeadasIds,
        tipoEncadeamentoPergunta,
        encadeamentosPerguntasIds,
        valor,
        checked,
        sessaoFormularioPerguntaId,
        sessaoFormularioId,
      };

      if (opcaoResposta.restritiva) {
        this.$refs.checkbox
          .filter((opc) => opc.id != elementRefId)
          .map((input) => (input.disabled = !input.disabled));
        //se nao estiver checked, remover a resposta restritiva e add todos que estavam
        //pre marcados
        this.removerTodasRespostasPergunta(sessaoFormularioPerguntaId);

        if (checked) {
          this.responderPerguntaMixin({ pergunta, opcaoResposta });
        } else {
          if (this.respostasSelecionadas && this.respostasSelecionadas.length) {
            this.respostasSelecionadas
              .filter(
                (opcaoSelecionada) => opcaoSelecionada.restritiva == false
              )
              .forEach((opcaoSelecionada) =>
                this.responderPerguntaMixin({
                  pergunta,
                  opcaoResposta: opcaoSelecionada,
                })
              );
          }
        }
      } else {
        if (!checked) {
          this.removerRespostaMixin(opcaoResposta);
        } else {
          this.responderPerguntaMixin({ pergunta, opcaoResposta });
        }
      }
      this.verificarPerguntaEncadeada(configPerguntaEncadeada);
    },
  },
  mounted() {},
};
</script>

<style scoped>
.add-border {
  border:2px solid green;
}
</style>



// WEBPACK FOOTER //
// src/components/PerguntasComponent/RespostaTipoCheckboxVertical.vue